import { __assign } from "tslib";
import { StoresWidgetID, MINICART_POPUP_URL, VIEWER_SCRIPT_DSN, CacheKey } from '../constants';
import { SiteStore } from './site-store/siteStore';
import { setSentryInstance, createControllerRaven, createFakeRaven, withErrorReporting, withErrorReportingWrapping, errorReporter, } from './errorReporter';
import { sentryConfPerController } from './sentryConf';
import { isWorker } from './utils';
function emptyCtrl() {
    return {
        pageReady: function () {
            //
        },
        exports: function () { return ({}); },
    };
}
var defaultOptions = {
    useWorkerRaven: true,
};
function openPopup(config, siteStore) {
    var popupUrl = MINICART_POPUP_URL;
    var cartIconConf = config.filter(function (c) { return c.type === StoresWidgetID.CART_ICON; });
    if (cartIconConf.length && cartIconConf[0].config.externalId) {
        popupUrl += "?externalId=" + cartIconConf[0].config.externalId;
    }
    siteStore.windowApis.openPersistentPopup(popupUrl, {
        theme: 'BARE',
        width: '0%',
        height: '100%',
        position: {
            origin: 'FIXED',
            placement: 'TOP_RIGHT',
            x: 0,
            y: 0,
        },
    }, (cartIconConf.length && cartIconConf[0].compId) || config[0].compId);
}
function getControllerFactory(controllerInstances, controllerFactories, type) {
    var ctrlFactory;
    if (controllerInstances === null || controllerInstances === void 0 ? void 0 : controllerInstances[type]) {
        var controllerFunction = Object.keys(controllerInstances[type]).filter(function (k) {
            return k.toLowerCase().includes('controller');
        })[0];
        ctrlFactory = {
            factory: controllerInstances[type][controllerFunction],
            sentryDSN: sentryConfPerController[type],
        };
    }
    else if (controllerFactories === null || controllerFactories === void 0 ? void 0 : controllerFactories[type]) {
        ctrlFactory = controllerFactories[type];
    }
    return ctrlFactory;
}
function initController(ctrlFactory, context, props) {
    var ctrl;
    if (ctrlFactory) {
        var reportError_1 = context.createMonitoring(ctrlFactory.sentryDSN);
        var setPropsWithErrorsReporting = function (p) { return props.setProps(withErrorReporting(reportError_1)(p)); };
        ctrl = ctrlFactory.factory({
            config: props.config,
            compId: props.compId,
            context: context,
            setProps: setPropsWithErrorsReporting,
            platformAPIs: props.platformAPIs,
            reportError: reportError_1,
            type: props.type,
            warmupData: props.warmupData,
            wixCodeApi: props.wixCodeApi,
        });
        ctrl = withErrorReporting(reportError_1)(ctrl);
    }
    else {
        ctrl = emptyCtrl();
    }
    return ctrl;
}
export function createViewerScript(controllerFactories, options) {
    if (options === void 0) { options = {}; }
    var context = {};
    options = __assign(__assign({}, defaultOptions), options);
    return withErrorReportingWrapping({
        initAppForPage: function (initParams, apis, namespaces, platformServices) {
            var userMonitoringContext = {
                id: initParams.instanceId,
                url: namespaces.location.baseUrl,
                uuid: platformServices.bi.visitorId,
            };
            context.siteStore = new SiteStore(initParams, apis, namespaces, platformServices);
            if (options.useWorkerRaven) {
                var sentryInstance = platformServices.monitoring.createMonitor(VIEWER_SCRIPT_DSN, function (data) {
                    data.environment = 'Worker';
                    return data;
                });
                sentryInstance.setUserContext(userMonitoringContext);
                setSentryInstance(sentryInstance);
                context.createMonitoring = createControllerRaven(platformServices, userMonitoringContext, context.siteStore);
            }
            else {
                context.createMonitoring = createFakeRaven();
            }
            return context.siteStore.loadClientConfig().catch(errorReporter);
        },
        createControllers: function (controllerConfigs, controllerInstances) {
            var isDesktop = !context.siteStore.isMobile();
            var isViewer = context.siteStore.isSiteMode() || context.siteStore.isPreviewMode();
            var shouldOpenMiniCart = isDesktop && isViewer;
            if (context.siteStore.experiments.enabled('specs.stores.OpenMinicartOnce')) {
                if (context.siteStore.storage.memory.getItem(CacheKey.MINICART_OPEN) === 'true') {
                    shouldOpenMiniCart = false;
                }
                else {
                    context.siteStore.storage.memory.setItem(CacheKey.MINICART_OPEN, 'true');
                }
            }
            if (context.siteStore.experiments.enabled('specs.stores.FixMiniCartPreview')) {
                shouldOpenMiniCart = shouldOpenMiniCart && isWorker();
            }
            if (shouldOpenMiniCart) {
                openPopup(controllerConfigs, context.siteStore);
            }
            if (controllerConfigs.filter(function (c) { return c.type === StoresWidgetID.CART_ICON; }).length) {
                context.siteStore.cartActions.setCartIconExist();
            }
            return controllerConfigs.map(function (props) {
                var ctrlFactory = getControllerFactory(controllerInstances, controllerFactories, props.type);
                var ctrl = initController(ctrlFactory, context, props);
                return Promise.resolve(ctrl);
            });
        },
        exports: {
            registerOnCartChangeListener: function (listener) {
                context.siteStore.pubSubManager.subscribe('Cart.Changed', listener);
            },
        },
    });
}
//# sourceMappingURL=createViewerScript.js.map